import React, { useContext, useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { Link, useNavigate } from "react-router-dom";
import CountUp from "react-countup";
import { Calendar } from "primereact/calendar";
import { Nullable } from "primereact/ts-helpers";
import "bootstrap-daterangepicker/daterangepicker.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Cookies from "js-cookie";
import { BiRefresh } from "react-icons/bi";
import { motion } from "framer-motion";
import { Offcanvas } from "bootstrap";
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    Tooltip,
    Legend,
    ResponsiveContainer,
    RadialBarChart,
    RadialBar,
    PolarAngleAxis,
    CartesianGrid,
} from "recharts";
import { format } from "date-fns";
import { DateRange } from "react-date-range";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRotateLeft, faSearch } from "@fortawesome/free-solid-svg-icons";
import { DatePicker, Spin } from "antd";
import { all_routes } from "../../../router/all_routes";
import { useUserPermissions } from "../../../UserPermissionsContext";
import { InactivityContext } from "../InactivityContext";
import Counter from "../counter";
import AdminDashboardModal from "../../../mainMenu/adminDashboard/adminDashboardModal";
import bootstrap from "bootstrap";
import CommonSelect from "../../../../core/common/commonSelect";
import dayjs, { Dayjs } from "dayjs";

type User = {
    id: number;
    username: string;
    no_of_calls: number;
    no_of_calls_connected: number;
    no_of_sales: number;
};

type User1 = {
    branch_id: number;
    branch: string;
    sales: number;
}

type Class = {
    class_id: number;
    class_name: string;
    strength: number;
    last_year_sales_count: number;
    renewal_sales: number;
    new_sales: number;
    total_sales: number;
}

type GroupData = {
    total_sales: number;
    members: User[];
};

type SalesRank = {
    total_sales: number;
    branch_count: number;
    branches: User1[];
};

type ClassWizeSale = {
    branch_id: number;
    branch_name: string;
    class_wise_sales: Class[];
};

export type Option = {
    value: string;
    label: string;
};


const players = [
    {
        name: "Mohan",
        score: 425,
        image: "https://cdn-icons-png.flaticon.com/128/11918/11918393.png",
    },
    {
        name: "Pavan",
        score: 524,
        image: "https://cdn-icons-png.flaticon.com/128/11918/11918393.png",
    },
    {
        name: "Ravi",
        score: 625,
        image: "https://cdn-icons-png.flaticon.com/128/11918/11918393.png",
    },
];
const data135: Record<string, User[]> = {
    "Elite": [
        { id: 5, username: "yathin", no_of_calls: 0, no_of_calls_connected: 0, no_of_sales: 0 },
        { id: 23, username: "srilatha", no_of_calls: 12, no_of_calls_connected: 8, no_of_sales: 0 },
        // ...
    ],
    "Rapid Risers": [
        { id: 26, username: "pavan123", no_of_calls: 0, no_of_calls_connected: 0, no_of_sales: 0 },
        // ...
    ],
    "Challengers": [
        { id: 33, username: "Manikanta", no_of_calls: 0, no_of_calls_connected: 0, no_of_sales: 0 }
    ]
};
const salesData = [
    { name: "Alice", sales: 250, image: "https://cdn-icons-png.flaticon.com/128/11918/11918393.png" },
    { name: "Bob", sales: 180, image: "https://cdn-icons-png.flaticon.com/128/11918/11918393.png" },
    { name: "Charlie", sales: 300, image: "https://cdn-icons-png.flaticon.com/128/11918/11918393.png" },
    { name: "David", sales: 150, image: "https://cdn-icons-png.flaticon.com/128/11918/11918393.png" },
    { name: "Eve", sales: 220, image: "https://cdn-icons-png.flaticon.com/128/11918/11918393.png" },
];

const top3Agents = [
    {
        agent_id: 41,
        agent_name: "akhila_ms",
        sales_count: 6,
        agent_profile: "/media/pics/user_profile/photos/4e4615a870984277a21ca0244f3e041c.webp",
    },
    {
        agent_id: 9,
        agent_name: "Ganesh",
        sales_count: 5,
        agent_profile: "/media/pics/user_profile/photos/6afea485d1dc45debce76a1b78385b5d.webp",
    },
    {
        agent_id: 18,
        agent_name: "Syed_Marvan_Uddin",
        sales_count: 4,
        agent_profile: "/media/pics/user_profile/photos/2771465366ec41a9b3c0077d7de1da0f.webp",
    },
];

const data = [
    { name: "Mon", Calls: 120, Connected: 80 },
    { name: "Tue", Calls: 180, Connected: 110 },
    { name: "Wed", Calls: 150, Connected: 90 },
    { name: "Thu", Calls: 200, Connected: 140 },
    { name: "Fri", Calls: 170, Connected: 100 },
    { name: "Sat", Calls: 130, Connected: 70 },
];

const leaderboardData = [
    { name: "Amelia Kerr", points: 720, position: 1 },
    { name: "Jess Kerr", points: 720, position: 2 },
    { name: "Eden Carson", points: 720, position: 3 },
];

const data5 = [
    { day: "Mon", sales: 40, connected: 80 },
    { day: "Tue", sales: 90, connected: 140 },
    { day: "Wed", sales: 70, connected: 100 },
    { day: "Thu", sales: 80, connected: 120 },
    { day: "Fri", sales: 50, connected: 90 },
    { day: "Sat", sales: 85, connected: 110 },
];

const dataL = [
    {
        profileImage: 'https://cdn-icons-png.flaticon.com/128/11918/11918393.png',
        image: '/assets/img/Vector (1).png',
        name: 'John Doe',
        saleCount: 150
    },
    {
        profileImage: 'https://cdn-icons-png.flaticon.com/128/11918/11918393.png',
        image: '/assets/img/Vector.png',
        name: 'Jane Smith',
        saleCount: 200
    },
    {
        profileImage: 'https://cdn-icons-png.flaticon.com/128/11918/11918393.png',
        image: '/assets/img/Vector (2).png',

        name: 'Mark Johnson',
        saleCount: 100
    }
];

type Dashboard = {
    id: number;
    agent_name: string;
    status_name: string;
    updated_at: string;
    last_login_time: string;
    agent: number;
    status: number;
    calls: string;
    connected: string;
    missed: string;
    interested: string;
    callbacks: string;
    sale: string;
    performance: string;
    total_ideal_time: string;
    conversation_time: string;
};

const topThree = [
    { name: "Ravi", score: 625, rank: 1 },
    { name: "Mohan", score: 425, rank: 2 },
    { name: "Pavan", score: 524, rank: 3 },
];

// const others = [
//     { name: "Akash", score: 3768 },
//     { name: "Papa Rao", score: 3768 },
//     { name: "Chikitha", score: 3768 },
//     { name: "Anil", score: 3768 },
//     { name: "Doopesh", score: 3768 },
// ];

interface Winner {
    name: string;
    rank: number;
    image: string;
}

const winners = [
    {
        rank: 1,
        name: "John",
        score: 4500,
        image: "https://cdn-icons-png.flaticon.com/128/11918/11918393.png",
    },
    {
        rank: 2,
        name: "Emma",
        score: 4200,
        image: "https://cdn-icons-png.flaticon.com/128/11918/11918393.png",
    },
    {
        rank: 3,
        name: "Liam",
        score: 3900,
        image: "https://cdn-icons-png.flaticon.com/128/11918/11918393.png",
    },
    {
        rank: 4,
        name: "Olivia",
        score: 3768,
        image: "https://cdn-icons-png.flaticon.com/128/11918/11918393.png",
    },
    {
        rank: 5,
        name: "Noah",
        score: 3600,
        image: "https://cdn-icons-png.flaticon.com/128/11918/11918393.png",
    },
    {
        rank: 6,
        name: "Sophia",
        score: 3450,
        image: "https://cdn-icons-png.flaticon.com/128/11918/11918393.png",
    },
    {
        rank: 1,
        name: "John",
        score: 4500,
        image: "https://cdn-icons-png.flaticon.com/128/11918/11918393.png",
    },
    {
        rank: 2,
        name: "Emma",
        score: 4200,
        image: "https://cdn-icons-png.flaticon.com/128/11918/11918393.png",
    },
    {
        rank: 3,
        name: "Liam",
        score: 3900,
        image: "https://cdn-icons-png.flaticon.com/128/11918/11918393.png",
    },
    {
        rank: 4,
        name: "Olivia",
        score: 3768,
        image: "https://cdn-icons-png.flaticon.com/128/11918/11918393.png",
    },
    {
        rank: 5,
        name: "Noah",
        score: 3600,
        image: "https://cdn-icons-png.flaticon.com/128/11918/11918393.png",
    },
    {
        rank: 6,
        name: "Sophia",
        score: 3450,
        image: "https://cdn-icons-png.flaticon.com/128/11918/11918393.png",
    },
];

const barImages = [
    '/assets/img/Vector (1).png', // Bar image 1
    '/assets/img/Vector.png', // Bar image 2
    '/assets/img/Vector (2).png', // Bar image 3
];

const profileImages = [
    'https://cdn-icons-png.flaticon.com/128/11918/11918393.png', // Profile image 1
    'https://cdn-icons-png.flaticon.com/128/11918/11918393.png', // Profile image 2
    'https://cdn-icons-png.flaticon.com/128/11918/11918393.png', // Profile image 3
];

type TodayLeads = {
    total_leads: number;
    call_logs: number;
    connected_call_logs: number;
    interested: number;
    call_backs: number;
    sales: number;
    average_conversation_duration: string;
    "call/leads_per": number;
    calls_connected_per: number;
    interested_per: number;
    call_backs_per: number;
    sales_per: number;
    not_interested: number;
    not_interested_per: number;
    achieved_amount: string;
    target_amount: string;
    target_amount_per: number;
    weekly_sales_target: number;
    weekly_sales_achieved: number;
    weekly_sales_achieved_percentage: number;
    target_conversation_time: any;
    conversation_time: any;
    conversation_efficiency: number;
    total_calls: number;
    connected_calls: number;
    call_connected_per: number;
    unique_leads_touch: number;
    unique_leads_connected: number;
    unique_leads_connected_per: number;
    total_sales: number;
    // sales_per:number;
};

interface SalesData {
    rank: number;
    profilePic: string;
    name: string;
    sales: number;
}

interface Leaderboard {
    rank: number;
    id: number,
    username: string;
    sales_count: number;
    photo: string;
    sl_no: number;
}
interface CallsDaily {
    calls: number;
    connected: number,
    label: string
}

interface Data {
    Daily: SalesData[];
    Weekly: SalesData[];
    Monthly: SalesData[];
    AllTime: SalesData[];
}

const data9: Data = {
    Daily: [
        { rank: 1, profilePic: 'https://cdn-icons-png.flaticon.com/128/11918/11918393.png', name: 'Alice', sales: 10 },
        { rank: 2, profilePic: 'https://cdn-icons-png.flaticon.com/128/11918/11918393.png', name: 'Bob', sales: 8 },
        { rank: 3, profilePic: 'https://cdn-icons-png.flaticon.com/128/11918/11918393.png', name: 'Charlie', sales: 5 },
    ],
    Weekly: [
        { rank: 1, profilePic: 'https://cdn-icons-png.flaticon.com/128/11918/11918393.png', name: 'David', sales: 50 },
        { rank: 2, profilePic: 'https://cdn-icons-png.flaticon.com/128/11918/11918393.png', name: 'Eve', sales: 45 },
        { rank: 3, profilePic: 'https://cdn-icons-png.flaticon.com/128/11918/11918393.png', name: 'Frank', sales: 30 },
    ],
    Monthly: [
        { rank: 1, profilePic: 'https://cdn-icons-png.flaticon.com/128/11918/11918393.png', name: 'Grace', sales: 200 },
        { rank: 2, profilePic: 'https://cdn-icons-png.flaticon.com/128/11918/11918393.png', name: 'Heidi', sales: 180 },
        { rank: 3, profilePic: 'https://cdn-icons-png.flaticon.com/128/11918/11918393.png', name: 'Ivan', sales: 150 },
    ],
    AllTime: [
        { rank: 1, profilePic: 'https://cdn-icons-png.flaticon.com/128/11918/11918393.png', name: 'Judy', sales: 1000 },
        { rank: 2, profilePic: 'https://cdn-icons-png.flaticon.com/128/11918/11918393.png', name: 'Karl', sales: 950 },
        { rank: 3, profilePic: 'https://cdn-icons-png.flaticon.com/128/11918/11918393.png', name: 'Leo', sales: 900 },
    ],
};

interface SalesDaily {
    label: string,
    sales: number,
}
interface Branch {
    branch_id: number,
    name: string,
    label: string,
}

interface SortConfig {
    field: "sales" | "strength";
    direction: "asc" | "desc";
    secondaryDirection: "asc" | "desc"; // New state to track secondary direction
}

const EmployeeDashboard = () => {
    const routes = all_routes;
    const navigate = useNavigate();
    const [date, setDate] = useState<Nullable<Date>>(null);
    const { userPermissions, webApi } = useUserPermissions();
    const [dashboardData, setDashboardData] = useState<Dashboard[]>([]);
    const jwtToken = Cookies.get("authToken");
    const context = useContext(InactivityContext);
    const [todayLeads, setTodayLeads] = useState<TodayLeads | null>(null);
    const [top3Wizklub, setTop3Wizlub] = useState<any[]>([]);
    const [overall, setoverall] = useState<any[]>([]);
    const [dateRangeLeads, setDateRangeLeads] = useState<TodayLeads | null>(null);
    const [todayLeadsLoading, setTodayLeadsLoading] = useState(false);
    const [DateRangeLeadsLoading, setDateRangeLeadsLoading] = useState(false);
    const [leaderboard, setLeaderBoard] = useState<Leaderboard[]>([]);
    const [CallsDailyGraph, setCallsDailyGraph] = useState<CallsDaily[]>([])
    const [salesDaily, setSalesDaily] = useState<SalesDaily[]>([]);
    const [groupsData, setGroupsData] = useState<Record<string, GroupData>>({});
    const [SalesRank, setSalesRank] = useState<Record<string, SalesRank>>({});
    const [classWizeSalesReport, setClassWizeSalesReport] = useState<ClassWizeSale | null>(null);
    const [branchesDropdown, setBranchesDropdown] = useState<Branch[]>([]);
    const sortedData = [...salesData].sort((a, b) => b.sales - a.sales);
    const maxSales = Math.max(...salesData.map((s) => s.sales));
    const [refreshIsLoading, seteRfreshIsLoading] = useState(false);
    const [groupsCardLoading, setGroupsCardLoading] = useState(false);
    const [SalesRankLoading, setSalesRankLoading] = useState(false);
    const [classWizeSalesLoading, setClassWizeSalesLoading] = useState(false);
    const [selectedBranch, setSelectedBranch] = useState<Option | null>(null);
    const [sortConfig, setSortConfig] = useState<SortConfig>({
        field: "sales",
        direction: "desc",
        secondaryDirection: "desc",
    });
    const [branchName, setBranchName] = useState("");
    const today = new Date();

    const [selectedDate, setSelectedDate] = useState<Dayjs>(dayjs());

    const handleBranchChange = async (selected: Option | null) => {
        const branch = branchesDropdown.find(
            (c) => c.branch_id === parseInt(selected?.value || "")
        );
        setSelectedBranch(
            branch
                ? {
                    value: branch.branch_id.toString(),
                    label: branch.name,
                }
                : null
        );
    };




    const [salesVsConnected, setSalesVsConnected] = useState({
        total_sales: 0,
        total_connected: 0,
        sales_vs_connected_per: 0,
        results: [],
    });
    const [salesVsCallBack, setSalesVsCallBack] = useState({
        total_sales: 0,
        total_call_backs: 0,
        sales_vs_call_backs_per: 0,
        results: [],
    });
    const [salesVsIntrested, setSalesVsIntrested] = useState({
        total_sales: 0,
        total_interested: 0,
        sales_vs_interested_per: 0,
        results: [],
    });

    const [activeTab, setActiveTab] = useState<'Daily' | 'Weekly' | 'Monthly' | 'AllTime'>('Daily');
    const checkPermission = (action: any, subject: any) => {
        return userPermissions.some(
            (ability) => ability.action === action && ability.subject === subject
        );
    };

    useEffect(() => {
        setLeaderBoard([]);
        fetchLeaderboard(tabToDays[activeTab])
    }, [activeTab]);

    const tabMapping: { [key: string]: 'Daily' | 'Weekly' | 'Monthly' | 'AllTime' } = {
        'Today': 'Daily',
        'Last 7 days': 'Weekly',
        'Last 30 days': 'Monthly',
        'AllTime': 'AllTime'
    };

    const tabToDays = {
        Daily: "today",
        Weekly: "week",
        Monthly: "month",
        AllTime: "all",
    };


    const top3 = leaderboard.slice(0, 3); // Top 3 agents
    const others = leaderboard.slice(3);
    const reorderedTop3 = [top3[1], top3[0], top3[2]].filter(Boolean);


    if (!context) {
        throw new Error("SomeComponent must be used within an InactivityProvider");
    }

    const { isIdle, isStatusChange, setIsStatusChange } = context;

    const [monitoringStatus, setMonitoringStatus] = useState<
        { id: number; name: string }[]
    >([]);

    const options = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${jwtToken}`,
        },
    };

    const formatDate = (date: Dayjs): string => {
        return date.format("YYYY-MM-DD");
    };

    const fetchData = async () => {
        seteRfreshIsLoading(true); // Set loading to true
        try {
            const dateStr = formatDate(selectedDate);
            const response = await fetch(
                `${webApi}/dashboard/employee_calling_monitoring/`,
                options
            );
            const data = await response.json();
            setDashboardData(data.results);
        } catch (error) {
            console.error("Failed to fetch data:", error);
        } finally {
            seteRfreshIsLoading(false); // Set loading back to false after fetch is complete
        }
    };

    useEffect(() => {
        fetchData();
    }, [selectedDate])

    const fetchLeaderboard = async (days: string) => {
        const response = await fetch(
            `${webApi}/dashboard/wizklub_leader_board/?filter=${days}`,
            options
        );
        const data = await response.json();
        setLeaderBoard(data);
    };


    const fetchCalldDailyGraph = async () => {
        const response = await fetch(
            `${webApi}/dashboard/wizklub_calls_graph/`,
            options
        );
        const data = await response.json();
        setCallsDailyGraph(data);
    };

    const fetchGroupsCard = async (startDate: string, endDate: string): Promise<void> => {
        try {
            setGroupsCardLoading(true);

            const response = await fetch(
                `${webApi}/dashboard/user_wizklub_sales_rank_group/?from_date=${startDate}&to_date=${endDate}`,
                options
            );

            if (!response.ok) {
                throw new Error(`Failed to fetch data: ${response.statusText}`);
            }

            const data = await response.json();
            setGroupsData(data);
        } catch (error) {
            console.error("Error fetching group card data:", error);
        } finally {
            setGroupsCardLoading(false);
        }
    };

    const fetchSalesRank = async () => {
        try {
            setSalesRankLoading(true);
            const { field, direction, secondaryDirection } = sortConfig;
            const secondaryField = field === "sales" ? "strength" : "sales";

            // Primary field with direction, secondary field with its own direction
            const primaryOrdering = direction === "desc" ? `-${field}` : field;
            const secondaryOrdering = secondaryDirection === "desc" ? `-${secondaryField}` : secondaryField;
            const orderingParam = `${primaryOrdering},${secondaryOrdering}`;

            const response = await fetch(
                `${webApi}/branches/wizklub_branch_sales_ranking_for_trainers/?ordering=${orderingParam}`,
                options
            );

            if (!response.ok) throw new Error("Failed to fetch");

            const data = await response.json();

            setSalesRank(data);
        } catch (error) {
            console.error("Fetch error:", error);
        } finally {
            setSalesRankLoading(false);
        }
    };

    const handleSortClick = (clickedField: "sales" | "strength") => {
        setSortConfig((prev) => {
            if (prev.field === clickedField) {
                // Flip direction if same field
                return {
                    ...prev,
                    direction: prev.direction === "asc" ? "desc" : "asc",
                };
            } else {
                // New field - maintain the other field's direction as secondary
                return {
                    field: clickedField,
                    direction: "asc", // Default direction for new primary field
                    secondaryDirection: prev.direction, // Preserve the previous primary direction
                };
            }
        });
    };

    useEffect(() => {
        fetchSalesRank();
    }, [sortConfig]);



    const fetchSalesGraph = async () => {
        const response = await fetch(
            `${webApi}/dashboard/wizklub_trainer_sales_graph_dashboard/`,
            options
        );
        const data = await response.json();
        setSalesDaily(data);
    };

    const fetchSalesVsConnected = async () => {
        const response = await fetch(
            `${webApi}/dashboard/wizklub_sales_vs_connected_call_graph/`,
            options
        );
        const data = await response.json();
        setSalesVsConnected(data);
    };

    const fetchSalesVsCallBacks = async () => {
        const response = await fetch(
            `${webApi}/dashboard/wizklub_sales_vs_call_backs_graph/`,
            options
        );
        const data = await response.json();
        setSalesVsCallBack(data);
    };

    const fetchSalesvsIntrested = async () => {
        const response = await fetch(
            `${webApi}/dashboard/wizklub_sales_vs_interested_graph/`,
            options
        );
        const data = await response.json();
        setSalesVsIntrested(data);
    };

    const fetchMonitoringStatusDropdown = async () => {
        const response = await fetch(
            `${webApi}/user_monitoring/monitoring_status_types_dropdown/`,
            options
        );
        const data = await response.json();
        setMonitoringStatus(data);
    };

    const fetchTop3 = async () => {
        const response = await fetch(
            `${webApi}/dashboard/wizklub_today_top_three_trainer_performers/`,
            options
        );
        const data = await response.json();
        setTop3Wizlub(data);
    };

    const fetchOverall = async () => {
        const response = await fetch(
            `${webApi}/dashboard/wizklub_orverall_top_three_trainer_performers/`,
            options
        );
        const data = await response.json();
        setoverall(data);
    };

    const fetchBranches = async () => {
        const response = await fetch(
            `${webApi}/branches/wizklub_branches_dropdown/`,
            options
        );
        const data = await response.json();
        setBranchesDropdown(data);
    };

    const fetchClassWizeSales = async () => {
        setClassWizeSalesLoading(true); // Start loading
        try {
            // Build URL conditionally
            const url = selectedBranch
                ? `${webApi}/dashboard/branch_class_wise_sales_report/?branch_id=${selectedBranch.value}`
                : `${webApi}/dashboard/branch_class_wise_sales_report/`;

            const response = await fetch(url, options);

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const data = await response.json();
            setBranchName(data.branch_name);
            const matchedBranch = branchesDropdown.find(
                (branch) => branch.branch_id === parseInt(data.branch_id)
            );

            setSelectedBranch(
                matchedBranch
                    ? {
                        value: matchedBranch.branch_id.toString(),
                        label: matchedBranch.name,
                    }
                    : null
            );
            setClassWizeSalesReport(data);

        } catch (error) {
            console.error("Failed to fetch class-wise sales:", error);
            // You can show a toast or set an error state here
        } finally {
            setClassWizeSalesLoading(false); // Stop loading
        }
    };

    const fetchClassWizeSales2 = async () => {
        setClassWizeSalesLoading(true); // Start loading
        try {
            // Build URL conditionally
            const url = selectedBranch
                ? `${webApi}/dashboard/branch_class_wise_sales_report/?branch_id=${selectedBranch.value}`
                : `${webApi}/dashboard/branch_class_wise_sales_report/`;

            const response = await fetch(url, options);

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const data = await response.json();
            setBranchName(data.branch_name);
            setClassWizeSalesReport(data);

        } catch (error) {
            console.error("Failed to fetch class-wise sales:", error);
            // You can show a toast or set an error state here
        } finally {
            setClassWizeSalesLoading(false); // Stop loading
        }
    };

    useEffect(() => {
        fetchClassWizeSales2()
    }, [selectedBranch])


    const branchOptions = branchesDropdown.map(branch => ({
        value: String(branch.branch_id),
        label: branch.label
    }));


    const fetchTodayLeadsData = async () => {
        setTodayLeadsLoading(true);
        try {
            const response = await fetch(
                `${webApi}/dashboard/employee_calling_today_dashboard/`,
                options
            );
            if (!response.ok) {
                const errorData = await response.json();
                if (errorData.code === "token_not_valid") {
                    navigate("/academic/sri-chaitanya/crm/landing-page");
                }
                throw new Error(errorData.detail || "Failed to fetch user data");
            }
            const data = await response.json();
            setTodayLeads(data);
        } catch (error) {
            console.error("Error fetching today's leads data:", error);
        } finally {
            setTodayLeadsLoading(false);
        }
    };

    const fetchDateRangeLeads = async (startDate: any, endDate: any) => {
        setDateRangeLeadsLoading(true);
        try {
            const response = await fetch(
                `${webApi}/dashboard/employee_calling_conversation_dashboard/?from_date=${startDate}&to_date=${endDate}`,
                options
            );
            const data = await response.json();
            setDateRangeLeads(data);
        } catch (error) {
            console.error("Error fetching date range leads:", error);
        } finally {
            setDateRangeLeadsLoading(false);
        }
    };

    useEffect(() => {
        if (!checkPermission("can_view_employee_dashboard", "Records")) {
            navigate(routes.crmLandingPage);
        } else {
            fetchData();
            fetchMonitoringStatusDropdown();
            fetchTodayLeadsData();
            fetchDateRangeLeads(startDate, endDate);
            // fetchLeaderboard("today");
            // fetchCalldDailyGraph();
            // fetchSalesGraph();
            // fetchSalesVsConnected();
            // fetchSalesVsCallBacks();
            // fetchSalesvsIntrested();
            // fetchTop3();
            // fetchOverall();
            // fetchGroupsCard(GroupsstartDate, GroupsendDate);
            // fetchSalesRank();
            // fetchBranches();
            // fetchClassWizeSales();
        }
    }, [userPermissions]);

    const data1 = [
        { name: "Mon", Calls: 80, Connected: 40 },
        { name: "Tue", Calls: 120, Connected: 90 },
        { name: "Wed", Calls: 100, Connected: 60 },
        { name: "Thu", Calls: 130, Connected: 85 },
        { name: "Fri", Calls: 90, Connected: 50 },
        { name: "Sat", Calls: 110, Connected: 80 },
    ];

    const [showCalendar, setShowCalendar] = useState(false);
    const [showCalendar1, setShowCalendar1] = useState(false);
    const [dateRange, setDateRange] = useState(() => {
        const savedDates = localStorage.getItem("dateRange");
        if (savedDates) {
            const parsed = JSON.parse(savedDates);
            return parsed.map((range: any) => ({
                ...range,
                startDate: range.startDate ? new Date(range.startDate) : null,
                endDate: range.endDate ? new Date(range.endDate) : null,
            }));
        }
        // ✅ Start with null values
        return [
            {
                startDate: null,
                endDate: null,
                key: "selection",
            },
        ];
    });

    useEffect(() => {
        localStorage.setItem("dateRange", JSON.stringify(dateRange));
    }, [dateRange]);

    useEffect(() => {
        if (dateRange[0].startDate === null && dateRange[0].endDate === null) {
            handleFetchResetDateRangeLEads();
        }
    }, [dateRange]);



    const startDate =
        dateRange?.[0]?.startDate instanceof Date && !isNaN(dateRange[0].startDate)
            ? format(dateRange[0].startDate, "yyyy-MM-dd")
            : "";

    const endDate =
        dateRange?.[0]?.endDate instanceof Date && !isNaN(dateRange[0].endDate)
            ? format(dateRange[0].endDate, "yyyy-MM-dd")
            : "";


    const [groupsdateRange, setGroupsDateRange] = useState(() => {
        const savedDates = localStorage.getItem("GroupsdateRange");
        if (savedDates) {
            const parsed = JSON.parse(savedDates);
            return parsed.map((range: any) => ({
                ...range,
                GroupsstartDate: range.GroupsstartDate ? new Date(range.GroupsstartDate) : null,
                GroupsendDate: range.GroupsendDate ? new Date(range.GroupsendDate) : null,
            }));
        }
        // ✅ Start with null values
        return [
            {
                GroupsstartDate: null,
                GroupsendDate: null,
                key: "selection",
            },
        ];
    });

    useEffect(() => {
        localStorage.setItem("GroupsdateRange", JSON.stringify(groupsdateRange));
    }, [groupsdateRange]);

    useEffect(() => {
        if (groupsdateRange[0].GroupsstartDate === null && groupsdateRange[0].GroupsendDate === null) {
            handleFetchResetGroupsData();
        }
    }, [groupsdateRange]);



    const GroupsstartDate =
        groupsdateRange?.[0]?.GroupsstartDate instanceof Date && !isNaN(groupsdateRange[0].GroupsstartDate)
            ? format(groupsdateRange[0].GroupsstartDate, "yyyy-MM-dd")
            : "";

    const GroupsendDate =
        groupsdateRange?.[0]?.GroupsendDate instanceof Date && !isNaN(groupsdateRange[0].GroupsendDate)
            ? format(groupsdateRange[0].GroupsendDate, "yyyy-MM-dd")
            : "";

    const handleFetchDateRangeLEads = () => {
        setShowCalendar1(false);
        fetchDateRangeLeads(startDate, endDate);
    };

    const handleFetchResetDateRangeLEads = () => {
        setShowCalendar1(false);
        fetchDateRangeLeads("", "");
    };

    const handleFetchGroupsData = () => {
        setShowCalendar(false);
        fetchGroupsCard(GroupsstartDate, GroupsendDate);
    };

    const handleFetchResetGroupsData = () => {
        setShowCalendar(false);
        fetchGroupsCard("", "");
    };

    const [selectedAgents, setSelectedAgents] = useState<number[]>([]);
    const [selectedStatus, setSelectedStatus] = useState<string>("");
    const handleCheckboxChange = (agentId: any) => {
        setSelectedAgents((prevSelected) => {
            if (prevSelected.includes(agentId)) {
                return prevSelected.filter((id) => id !== agentId);
            } else {
                return [...prevSelected, agentId];
            }
        });
    };

    const handleStatusChange = async (event: { target: { value: any } }) => {
        const statusId = event.target.value;
        setSelectedStatus(statusId);

        if (selectedAgents.length > 0 && statusId) {
            const payload = {
                user_ids: selectedAgents,
            };

            try {
                const response = await fetch(
                    `${webApi}/user_monitoring/change_multiple_agents_status/${statusId}/`,
                    {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${jwtToken}`,
                        },
                        body: JSON.stringify(payload),
                    }
                );

                if (response.ok) {
                    // Handle success (e.g., show a success message)
                    console.log("Status updated successfully");
                    setIsStatusChange(true);
                    // setTimeout(() => {
                    //   setIsStatusChange(false);
                    // }, 3000);
                    setSelectedAgents([]);
                    setSelectedStatus("");
                    fetchData();
                } else {
                    // Handle error (e.g., show an error message)
                    console.error("Failed to update status");
                }
            } catch (error) {
                console.error("Error:", error);
            }
        }
    };

    const winRate = 7.802; // Example Win Rate (0-10%)
    const growth = 0.5; // Example Growth (+ or -)

    // Radial Bar Chart Data (Segments)
    const data2 = [
        { value: 2, fill: "#FDCFE2" }, // Light Pink
        { value: 3, fill: "#F48FB1" }, // Medium Pink
        { value: 5, fill: "#D32D7E" }, // Dark Pink
    ];

    // Convert winRate (0-10%) to an angle (180° to 0°)
    const needleAngle1 = (winRate / 10) * 180 - 180;

    const data3 = [
        { day: "Mon", sales: 95 },
        { day: "Tue", sales: 130 },
        { day: "Wed", sales: 85 },
        { day: "Thu", sales: 120 },
        { day: "Fri", sales: 75 },
        { day: "Sat", sales: 110 },
        { day: "Sun", sales: 140 },
    ];

    const sampleData = [{ value: 7.802 }];
    const sampleGrowth = 0.5;

    const data = [{ value: winRate }];
    const needleAngle = 180 - (winRate / 10) * 180;

    const containerStyle = {
        position: "fixed" as "fixed",
        bottom: "10px",
        right: "10px",
        display: "flex",
        flexDirection: "column" as "column",
        gap: "10px",
        backgroundColor: "rgba(255, 255, 255, 0.8)", // Optional: Add background for better visibility
        borderRadius: "8px", // Optional: Rounded corners
        padding: "10px", // Optional: Add some padding
    };

    const [isOpen, setIsOpen] = useState(false);

    const toggleCard = () => {
        setIsOpen(!isOpen);

        const offcanvasEl = document.getElementById("offcanvasRight");
        if (offcanvasEl) { // ✅ Fix 2
            const bsOffcanvas = Offcanvas.getOrCreateInstance(offcanvasEl);
            isOpen ? bsOffcanvas.hide() : bsOffcanvas.show();
        }
    };

    useEffect(() => {
        document.body.style.overflow = isOpen ? "hidden" : "auto";
    }, [isOpen]);

    useEffect(() => {
        const offcanvasEl = document.getElementById("offcanvasRight");

        const handleShow = () => setIsOpen(true);
        const handleHide = () => setIsOpen(false);

        if (offcanvasEl) {
            offcanvasEl.addEventListener("show.bs.offcanvas", handleShow);
            offcanvasEl.addEventListener("hide.bs.offcanvas", handleHide);
        }

        return () => {
            if (offcanvasEl) {
                offcanvasEl.removeEventListener("show.bs.offcanvas", handleShow);
                offcanvasEl.removeEventListener("hide.bs.offcanvas", handleHide);
            }
        };
    }, []);



    return (
        <>
            <div className="page-wrapper" style={{ background: "#E5DCDF" }}>
                <div className="content" style={{ background: "#E5DCDF", padding: "15px" }}>
                    <>
                        <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
                            <div className="my-auto mb-2">
                                <h3 className="page-title mb-1">Employee Dashboard</h3>
                                <nav>
                                    <ol className="breadcrumb mb-0">
                                        <li className="breadcrumb-item active" aria-current="page">
                                            Employee Dashboard
                                        </li>
                                    </ol>
                                </nav>
                            </div>
                        </div>

                        <div className="row">
                            <div
                                style={{
                                    color: "#484453",
                                    marginBottom: "5px",
                                    fontSize: "16px",
                                    fontWeight: "bold",
                                }}
                            >
                                Today's Target Leads
                            </div>

                            {todayLeadsLoading ? (
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "flex-start",
                                        height: "100vh",
                                        paddingTop: "20px",
                                    }}
                                >
                                    <Spin /> {/* Display loader while loading */}
                                </div>
                            ) : (
                                <>
                                    <div className="col-xxl-12 col-md-12 col-sm-12">
                                        <div className="grid-container">
                                            {/* Connected/Leads Card */}
                                            <div className="dashboard-card">
                                                <div className="card-heading">Connected / Total Calls</div>
                                                <div className="card-score">
                                                    {todayLeads?.connected_calls} / {todayLeads?.total_calls}
                                                </div>
                                                <div className="progress-container">
                                                    <div className="progress-bar" style={{ width: `${todayLeads?.["call_connected_per"]}%` }}></div>
                                                </div>
                                                <span className="percentage-label">
                                                    {`${todayLeads?.["call_connected_per"]}%`}
                                                </span>
                                            </div>

                                            {/* Leads Connected Card */}
                                            <div className="dashboard-card">
                                                <div className="card-heading">Connected / Unique Lead Touch</div>
                                                <div className="card-score">
                                                    {todayLeads?.unique_leads_connected} / {todayLeads?.unique_leads_touch}
                                                </div>
                                                <div className="progress-container">
                                                    <motion.div
                                                        initial={{ width: 0 }}
                                                        animate={{ width: `${todayLeads?.["unique_leads_connected_per"]}%` }}
                                                        transition={{ duration: 1, ease: "easeInOut" }}
                                                        className="progress-bar"
                                                    />
                                                </div>
                                                <motion.span
                                                    initial={{ opacity: 0, x: -10 }}
                                                    animate={{ opacity: 1, x: 0 }}
                                                    transition={{ duration: 1, ease: "easeInOut" }}
                                                    className="percentage-label"
                                                >
                                                    {`${todayLeads?.["unique_leads_connected_per"]}%`}
                                                </motion.span>
                                            </div>

                                            {/* Interested Card */}

                                        </div>
                                    </div>
                                </>
                            )}
                            <hr className="group-divider" />
                            {/* Conversations Section */}
                            <div className="section-header">
                                <h4>Conversations</h4>
                                <div className="date-picker-container">
                                    <div
                                        className="date-picker-button"
                                        onClick={() => setShowCalendar1(!showCalendar1)}
                                    >
                                        {dateRange[0].startDate && dateRange[0].endDate
                                            ? `${format(dateRange[0].startDate, "dd MMM yy")} – ${format(dateRange[0].endDate, "dd MMM yy")}`
                                            : "Choose date"}
                                        <span className="dropdown-icon">▼</span>
                                        <FontAwesomeIcon
                                            icon={faSearch as IconProp}
                                            className="search-icon"
                                            onClick={handleFetchDateRangeLEads}
                                        />
                                        <FontAwesomeIcon
                                            icon={faRotateLeft as IconProp}
                                            className="search-icon"
                                            onClick={() => {

                                                setDateRange([
                                                    {
                                                        startDate: null,
                                                        endDate: null,
                                                        key: "selection",
                                                    },
                                                ]);
                                                // handleResetData()
                                            }}
                                        />
                                    </div>

                                    {showCalendar1 && (
                                        <div className="calendar-popup">
                                            <DateRange
                                                ranges={dateRange}
                                                onChange={(item) =>
                                                    setDateRange([
                                                        {
                                                            startDate: item.selection.startDate || null,
                                                            endDate: item.selection.endDate || null,
                                                            key: "selection",
                                                        },
                                                    ])
                                                }
                                                moveRangeOnFirstSelection={false}
                                                rangeColors={["blue"]}
                                            />
                                        </div>
                                    )}
                                </div>
                            </div>

                            {DateRangeLeadsLoading ? (
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "flex-start",
                                        height: "100vh",
                                        paddingTop: "20px",
                                    }}
                                >
                                    <Spin /> {/* Display loader while loading */}
                                </div>
                            ) : (
                                <>

                                    <div className="col-xxl-12 col-md-12 col-sm-12">
                                        {/* Left Half - Cards */}
                                        <div className="grid-container">
                                            {/* Connected/Leads Card */}
                                            <div className="dashboard-card">
                                                <div className="card-heading">Connected / Total Calls</div>
                                                <div className="card-score">
                                                    {dateRangeLeads?.connected_calls} / {dateRangeLeads?.total_calls}
                                                </div>
                                                <div className="progress-container">
                                                    <div className="progress-bar" style={{ width: `${dateRangeLeads?.["call_connected_per"]}%` }}></div>
                                                </div>
                                                <span className="percentage-label">
                                                    {`${dateRangeLeads?.["call_connected_per"]}%`}
                                                </span>
                                            </div>

                                            {/* Leads Connected Card */}
                                            <div className="dashboard-card">
                                                <div className="card-heading">Connected / Unique Lead Touch</div>
                                                <div className="card-score">
                                                    {dateRangeLeads?.unique_leads_connected} / {dateRangeLeads?.unique_leads_touch}
                                                </div>
                                                <div className="progress-container">
                                                    <motion.div
                                                        initial={{ width: 0 }}
                                                        animate={{ width: `${dateRangeLeads?.["unique_leads_connected_per"]}%` }}
                                                        transition={{ duration: 1, ease: "easeInOut" }}
                                                        className="progress-bar"
                                                    />
                                                </div>
                                                <motion.span
                                                    initial={{ opacity: 0, x: -10 }}
                                                    animate={{ opacity: 1, x: 0 }}
                                                    transition={{ duration: 1, ease: "easeInOut" }}
                                                    className="percentage-label"
                                                >
                                                    {`${dateRangeLeads?.["unique_leads_connected_per"]}%`}
                                                </motion.span>
                                            </div>

                                            {/* Interested Card */}

                                        </div>
                                        <hr className="group-divider" />
                                        {/* Right Half - Bar Chart */}
                                        {/* <div className="conversation-chart">
                                    <h4>Calls Daily</h4>
                                    <ResponsiveContainer width="100%" height={250}>
                                        <BarChart data={CallsDailyGraph} barSize={10}>
                                            <XAxis
                                                dataKey="label"
                                                tick={{
                                                    fill: "#6c757d",
                                                    fontSize: 14,
                                                    fontWeight: "bold",
                                                }}
                                            />
                                            <YAxis tick={{ fill: "#6c757d", fontSize: 12 }} />
                                            <Tooltip />
                                            <Legend
                                                iconType="circle"
                                                wrapperStyle={{
                                                    fontSize: 14,
                                                    fontWeight: "bold",
                                                    color: "#6c757d",
                                                }}
                                            />
                                            <Bar
                                                dataKey="connected"
                                                fill="#4CAF50"
                                                radius={[5, 5, 0, 0]}
                                            />
                                            <Bar
                                                dataKey="calls"
                                                fill="#34303D"
                                                radius={[5, 5, 0, 0]}
                                            />
                                        </BarChart>
                                    </ResponsiveContainer>
                                </div> */}
                                    </div>

                                </>
                            )}

                            {/* Agent Activity Section */}
                            <div className="agent-activity-container">
                                <div className="agent-activity-header">
                                    <h2>Agent Activity</h2>
                                    <select
                                        onChange={handleStatusChange}
                                        value={selectedStatus}
                                        disabled={selectedAgents.length === 0}
                                    >
                                        <option value="">Select</option>
                                        {monitoringStatus &&
                                            monitoringStatus.map((status) => (
                                                <option key={status.id} value={status.id}>
                                                    {status.name}
                                                </option>
                                            ))}
                                    </select>
                                    {/* <DatePicker
                                        value={selectedDate}
                                        onChange={(date) => {
                                            if (date) setSelectedDate(date);
                                        }}
                                        format="YYYY-MM-DD"
                                        placeholder="Select Date"
                                        disabledDate={(current) => current && current > dayjs()}
                                    /> */}
                                    <BiRefresh
                                        className={`refresh-icon ${refreshIsLoading ? "spin" : ""}`}
                                        onClick={fetchData}
                                    />

                                </div>

                                <div className="agent-activity-table-container">
                                    <table className="agent-activity-table">
                                        <thead>
                                            <tr>
                                                <th>Action</th>
                                                <th>Agent Name</th>
                                                <th>Status</th>
                                                <th>Session Duration</th>
                                                <th>Calls</th>
                                                <th>Connected</th>
                                                <th>Conversation Time</th>
                                                {/* <th>Sale</th> */}
                                                <th>Ideal Time</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {dashboardData &&
                                                dashboardData.map((agent, index) => (
                                                    <tr key={index}>
                                                        <td>
                                                            <input
                                                                type="checkbox"
                                                                checked={selectedAgents.includes(agent.id)}
                                                                onChange={() => handleCheckboxChange(agent.id)}
                                                                disabled={
                                                                    agent.status_name === "Offline" ||
                                                                    agent.status_name === "On Call"
                                                                }
                                                            />
                                                        </td>
                                                        <td>{agent.agent_name}</td>
                                                        <td>{agent.status_name}</td>
                                                        <td>
                                                            <Counter updatedAt={agent.updated_at} />
                                                        </td>
                                                        <td>{agent.calls}</td>
                                                        <td>{agent.connected}</td>
                                                        <td>{agent.conversation_time}</td>
                                                        {/* <td>{agent.sale}</td> */}
                                                        <td>{agent.total_ideal_time}</td>
                                                    </tr>
                                                ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <hr className="group-divider" />

                            {/* Sales Summary Section */}
                            
                        </div>
                    </>
                </div>

                {/* Leaderboard Toggle Button */}
                {/* <div className="leaderboard-toggle">
                    {!isOpen && (
                        <img
                            src="/assets/img/podium_11543322.png"
                            alt="Leaderboard"
                            title="Leaderboard"
                            onClick={toggleCard}
                            data-bs-toggle="offcanvas"
                            data-bs-target="#offcanvasRight"
                            aria-controls="offcanvasRight"
                        />
                    )}
                </div> */}

                {/* Leaderboard Offcanvas */}
                <div
                    className="offcanvas offcanvas-end leaderboard-offcanvas"
                    tabIndex={-1}
                    id="offcanvasRight"
                    aria-labelledby="offcanvasRightLabel"
                >
                    <div className="offcanvas-header">
                        <div>
                            <h1>Leader Board</h1>
                        </div>
                        <button
                            type="button"
                            className="btn-close text-reset"
                            data-bs-dismiss="offcanvas"
                            aria-label="Close"
                            onClick={toggleCard}
                        />
                    </div>

                    <div className="offcanvas-body">
                        <div className="leaderboard-container">
                            <div className="leaderboard-top3">
                                {reorderedTop3.map((barImage, index) => (
                                    <div key={index} className="top3-item">
                                        <img
                                            src={barImage.photo ? `${webApi}${barImage.photo}` : 'https://cdn-icons-png.flaticon.com/128/11918/11918393.png'}
                                            alt={`Profile ${index + 1}`}
                                            className="top3-avatar"
                                        />
                                        <div className="top3-bar-container">
                                            <img
                                                src={barImages[index]}
                                                alt={`Bar ${index + 1}`}
                                                className="top3-bar"
                                            />
                                            <div className="top3-info">
                                                <div className="top3-rank">{barImage.sl_no}</div>
                                                <div className="top3-name">{barImage.username}</div>
                                                <div className="top3-sales">{barImage.sales_count}</div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            {/* Tabs Section */}
                            <div className="leaderboard-tabs">
                                {['Today', 'Last 7 days', 'Last 30 days', 'AllTime'].map((tab, index) => (
                                    <div
                                        key={index}
                                        className={`leaderboard-tab ${activeTab === tabMapping[tab] ? 'active' : ''}`}
                                        onClick={() => setActiveTab(tabMapping[tab])}
                                    >
                                        {tab}
                                    </div>
                                ))}
                            </div>

                            {/* Leaderboard List */}
                            <div className="leaderboard-list">
                                {others.map((item) => (
                                    <div key={item.id} className="leaderboard-item">
                                        <span className="item-rank">{item.sl_no}</span>
                                        <img
                                            src={item.photo ? `${webApi}${item.photo}` : 'https://cdn-icons-png.flaticon.com/128/11918/11918393.png'}
                                            alt={`Profile of ${item.username}`}
                                            className="item-avatar"
                                        />
                                        <span className="item-name">{item.username}</span>
                                        <span className="item-sales">{item.sales_count}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Modal */}
            <AdminDashboardModal />

            {/* CSS Styles */}
            <style>{`
       /* Page Wrapper */
.page-wrapper {
  min-height: 100vh;
}

/* Grid Container */
.grid-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 10px;
  justify-content: center;
}

/* Dashboard Cards */
.dashboard-card {
  height: 140px;
  padding: 10px;
  background: #f8f9fa;
  border-radius: 8px;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);
  text-align: center;
  position: relative;
  margin: 3px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.card-heading {
  font-size: 14px;
  font-weight: bold;
  color: #6c757d;
}

.card-score {
  font-size: 18px;
  font-weight: bold;
  margin-top: 5px;
}

.progress-container {
  width: 80%;
  height: 8px;
  background: #e9ecef;
  border-radius: 4px;
  margin-top: 8px;
  position: relative;
  overflow: hidden;
}

.progress-bar {
  height: 100%;
  background: #D32D7E;
  border-radius: 4px;
}

.percentage-label {
  position: absolute;
  left: 12%;
  bottom: 16px;
  font-size: 12px;
  font-weight: bold;
  color: #D32D7E;
}

/* Section Header */
.section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 20px 0 10px;
}

.section-header h4 {
  color: #484453;
  font-size: 18px;
  font-weight: bold;
  margin: 0;
}

/* Date Picker */
.date-picker-container {
  position: relative;
}

.date-picker-button {
  display: flex;
  align-items: center;
  padding: 8px 15px;
  background: white;
  border-radius: 20px;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);
  font-size: 12px;
  font-weight: bold;
  color: #34303D;
  cursor: pointer;
  border: 1px solid #ddd;
  min-width: 200px;
  justify-content: center;
  margin-top: 5px;
}

.dropdown-icon {
  margin-left: 10px;
}

.search-icon {
  margin-left: 10px;
  cursor: pointer;
}

.calendar-popup {
  position: absolute;
  z-index: 2000;
  background: white;
  border-radius: 10px;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.2);
  padding: 5px;
  left: -130px;
}

/* Conversations Grid */
.conversations-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;
  padding: 20px;
}

@media (min-width: 992px) {
  .conversations-grid {
    grid-template-columns: 1fr 1fr;
  }
}

.conversation-cards {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(170px, 1fr));
  gap: 15px;
}

.conversation-card {
  height: 140px;
  padding: 15px;
  background: #f8f9fa;
  border-radius: 12px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  text-align: center;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  transition: transform 0.2s ease-in-out;
  cursor: pointer;
}

.conversation-card:hover {
  transform: scale(1.05);
}

.group-divider {
  border: none;
  height: 2px;
  background-color: #353839;
  width: 100%;
  margin: 0;
  margin-top: 18px;
}

.conversation-chart {
  background: white;
  border-radius: 12px;
  padding: 10px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-height: 335px;
  width: 100%;
}

/* Agent Activity */
.agent-activity-container {
  padding: 16px;
  border-radius: 8px;
  width: 100%;
  color: black;
}

.agent-activity-header {
  background-color: #A43971;
  padding: 16px;
  border-radius: 8px 8px 0 0;
  color: white;
  display: flex;
  align-items: center;
}

.agent-activity-header h2 {
  font-size: 18px;
  font-weight: 600;
  color: white;
  margin: 0 16px 0 0;
}

.agent-activity-header select {
  margin-right: 8px;
}

.refresh-icon {
  margin-left: 8px;
  cursor: pointer;
  height: 19px;
  width: 35px;
}

.refresh-icon.spin {
  animation: spin 1s linear infinite;
}

.agent-activity-table-container {
  max-height: 400px;
  overflow-y: auto;
  overflow-x: auto;
  background-color: white;
  color: black;
  border-radius: 0 0 8px 8px;
}

.agent-activity-table {
  width: 100%;
  font-size: 14px;
  border-collapse: collapse;
}

.agent-activity-table th {
  padding: 8px;
  text-align: left;
  background-color: #F3F4F6;
  color: #374151;
}

.agent-activity-table td {
  padding: 8px;
  border-top: 1px solid #E5E7EB;
}

/* Sales Summary */
.sales-summary-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;
  padding: 20px;
}

@media (min-width: 768px) {
  .sales-summary-grid {
    grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  }
}

.top3-card {
  background: white;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  text-align: center;
  width: 100%;
  min-width: 350px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 300px;
}

.top3-header {
  background: #4A4A5C;
  color: white;
  padding: 8px;
  font-size: 24px;
  font-weight: bold;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}

.top3-content {
  margin-top: 60px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  gap: 12px;
}

.top3-agent {
  flex: 1;
  padding: 12px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.agent-avatar {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  object-fit: cover;
  margin-top: 8px;
  margin-bottom: 8px;
}

.agent-name {
  font-weight: bold;
  text-align: center;
}

.agent-sales {
  font-size: 12px;
  color: #555;
}

.sales-chart {
  background: white;
  border-radius: 12px;
  padding: 10px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-height: 335px;
  width: 100%;
}

/* Sales vs Connected Grid */
.sales-vs-connected-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  padding: 20px;
}

@media (min-width: 992px) {
  .sales-vs-connected-grid {
    grid-template-columns: repeat(auto-fit, minmax(520px, 1fr));
  }
}

.sales-vs-connected-card {
  background: white;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  text-align: center;
  width: 100%;
  min-width: 350px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.svc-header {
  background: #4A4A5C;
  color: white;
  padding: 16px;
  font-size: 24px;
  font-weight: bold;
  position: absolute;
  width: 100%;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  text-align: center;
  top: 0;
  left: 0;
  right: 0;
}

.svc-chart {
  margin-top: 200px;
  width: 100%;
  position: relative;
}

/* Group Data Card */
.group-data-card {
  background: white;
  border-radius: 12px;
  padding-top: 70px;
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 20px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  width: 100%;
  min-width: 350px;
  position: relative;
  overflow: hidden;

  max-height: 500px;
  display: flex;
  flex-direction: column;
}
.group-header {
  background: #4A4A5C;
  color: white;
  padding: 12px;
  font-size: 20px;
  font-weight: bold;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  text-align: center;
  z-index: 1;
}

.group-table-container {
  flex-grow: 1;
  overflow-x: auto;
  overflow-y: auto;
  max-height: 100%;
}

.group-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  border-radius: 8px;
  overflow: hidden;
  margin-top: 10px;
  box-shadow: 0 0 0 1px #e0e0e0;
}

.group-table th {
  padding: 12px 16px;
  text-align: left;
  font-weight: bold;
  font-size: 14px;
  color: #4a4a4a;
  border-bottom: 1px solid #e0e0e0;
  white-space: nowrap;
}

.group-table td {
  padding: 12px 16px;
  font-size: 14px;
  color: #333;
  border-bottom: 1px solid #eee;
}

.group-table tr:nth-child(even) {
  background-color: #f9f9f9;
}

.group-table tr:hover {
  background-color: #f0f7ff;
}

/* Leaderboard Toggle */
.leaderboard-toggle {
  position: fixed;
  bottom: 10px;
  right: 4px;
  z-index: 2000;
}

.leaderboard-toggle img {
  width: 49px;
  height: 49px;
  cursor: pointer;
  margin-bottom: 10px;
}

/* Leaderboard Offcanvas */
.leaderboard-offcanvas {
  max-width: 29%;
  background: linear-gradient(0deg, white 0%, #DFE3FF 100%);
}

.offcanvas-header {
  text-align: center;
  padding: 1rem;
}

.offcanvas-header h1 {
  color: #364D9B;
}

.leaderboard-container {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.leaderboard-top3 {
  display: flex;
  justify-content: space-around;
  align-items: flex-end;
  padding: 10px;
  height: 300px;
  position: relative;
  margin-top: 15px;
}

.top3-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 5px;
  position: relative;
}

.top3-avatar {
  margin-bottom: 10px;
  border-radius: 50%;
  width: 70px;
  height: 70px;
  object-fit: cover;
}

.top3-bar-container {
  position: relative;
  width: 100px;
  height: auto;
}

.top3-bar {
  width: 100%;
  height: auto;
}

.top3-info {
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  font-weight: bold;
  font-size: 0.8rem;
}

.top3-rank {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: white;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
}

.top3-name {
  color: white;
  width: 70px;
  white-space: normal;
  word-wrap: break-word;
  overflow-wrap: break-word;
}

.top3-sales {
  color: white;
}

/* Leaderboard Tabs */
.leaderboard-tabs {
  display: flex;
  justify-content: space-around;
  margin-top: 20px;
}

.leaderboard-tab {
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
  text-align: center;
  transition: background-color 0.3s;
}

.leaderboard-tab:hover {
  background-color: #e0e0e0;
}

.leaderboard-tab.active {
  background-color: #d0d0d0;
  font-weight: bold;
}

/* Leaderboard List */
.leaderboard-list {
  margin-top: 20px;
  overflow-y: auto;
  flex-grow: 1;
}

.leaderboard-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
  margin-bottom: 10px;
  color: #3D4E9B;
  font-weight: bold;
  font-size: 1rem;
  width: 85%;
}

.item-rank {
  flex: 1;
  text-align: left;
}

.item-avatar {
  margin: 0 5px 0 -50px;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  object-fit: cover;
}

.item-name {
  flex: 1;
  text-align: center;
  margin-left: 5px;
  width: 70px;
  white-space: normal;
  word-wrap: break-word;
  overflow-wrap: break-word;
}

.item-sales {
  flex: 1;
  text-align: right;
}

/* Animations */
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
      `}</style>
        </>
    );
};

export default EmployeeDashboard;
